




































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
    deleteUser,
    getCompanies,
    getPrograms,
    deleteProgram,
    deleteLot,
    getLots,
    pushImagesProgram,
    deleteImageProgram,
} from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import User from '../models/User';
import AuthModule from '../store/AuthModule';
import get from 'lodash/get';
import { formatLotType, formatLotStatus } from '@/data/lot';
import Program from '../models/Program';
import Lot from '../models/Lot';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import Lightbox from '@/components/Lightbox.vue';
import Datatable from '@/components/Datatable.vue';
import { BACKEND_URL } from '../helpers/constants';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    components: {
        Lightbox,
        Datatable,
    },
    filters: {
        formatLotType,
        formatLotStatus,
    },
})
export default class Lots extends Vue {
    loading: boolean = false;
    BACKEND_URL = BACKEND_URL;
    @Prop() images!: any[];
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 10,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Aperçu',
            dataIndex: 'preview',
            align: 'center',
            scopedSlots: {
                customRender: 'preview',
            },
        },
        {
            title: 'Nom',
            dataIndex: 'image',
            scopedSlots: {
                customRender: 'name',
            },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];
    deleteText = {
        confirm: {
            title: `Suppression de l'image`,
            content: `Voulez-vous vraiment supprimer l'image ?`,
        },
        notify: {
            title: "L'image supprimé",
            content: `L'image a bien été supprimé`,
        },
    };
    imageModal: string = '';

    @Watch('images', { deep: true })
    onImages() {
        // @ts-ignore
        this.$refs.datatable.refresh();
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: any | null;
    }) {
        const action = ev.action;
        const image: any | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                break;
            case 'delete':
                if (image && image.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                }
                await deleteImageProgram(
                    +this.$route.params.programID,
                    image.id
                );
                this.$emit('fetch');
                break;
        }
    }

    addImage() {
        // @ts-ignore
        this.$refs.fileinput.click();
    }

    async fetch(meta: MetaDatatable) {
        const page = Math.max(1, this.meta.page);
        const secondary = this.images.filter(
            item => item.type === 'images_secondary_perspective'
        );
        const slice = secondary.slice(
            (page - 1) * meta.perPage,
            page * meta.perPage
        );

        return {
            meta: {
                total: secondary.length,
                pages: Math.ceil(secondary.length / meta.perPage),
            },
            data: slice,
        };
    }

    async fileChangeListener(ev: Event) {
        const target: HTMLInputElement = ev.target as HTMLInputElement;
        const files: FileList = target.files as FileList;
        const arrayImages: any[] = [];

        if (FileReader && files && files.length) {
            for (let i = 0; i < files.length; i++) {
                (file => {
                    const name = file.name;
                    const fr = new FileReader();
                    fr.onload = async () => {
                        arrayImages.push({ file_name: name, image: fr.result });

                        if (arrayImages.length === files.length) {
                            try {
                                this.loading = true;
                                await pushImagesProgram(
                                    +this.$route.params.programID,
                                    arrayImages,
                                    'images_secondary_perspective'
                                );
                                this.$emit('fetch');

                                const $vs = (this as any).$vs;
                                $vs.notify({
                                    color: 'success',
                                    position: 'top-right',
                                    title: 'Importation réussie',
                                    text: 'Image importée avec succès',
                                });
                            } catch (error) {
                                console.error(error);
                            } finally {
                                this.loading = false;
                            }
                        }
                    };
                    fr.readAsDataURL(file);
                })(files[i]);
            }
        }
    }

    deleteDialog(lot: Lot) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(lot),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async acceptDeleteAlert(lot: Lot) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: lot });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de l'image`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }
}
